module.exports = __webpack_public_path__ + "static/media/logo2.2be90d73.webp";